import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  connect() {
    this.element.addEventListener("click", (event) => {
      if (event.target.classList.contains("clear-btn")) {
        this.clearFilter(event.target);
      }
    });
  }
  
  clearFilter(button) {
    const input = document.querySelector(`#q_${button.id}`)

    if (input) {
      input.value = "";
      input.dispatchEvent(new Event("change"));
    }
    document.querySelector("#affiliate_facility_search").submit();
  }
}
